import { Component, computed, Signal, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { select } from '@ngxs/store';
import { GbrUser } from '@gbr-monorepo/interfaces';
import { UserState } from '../auth/state/user.state';
import { environment } from '../../environments/environment';
import { DashboardTileComponent } from './dashboard-tile/dashboard-tile.component';
import { DashboardItem } from './dashboard.model';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslateModule, DashboardTileComponent]
})
export class DashboardComponent {
    protected user: Signal<GbrUser | undefined> = select(UserState.user);
    protected isAdmin: Signal<boolean | undefined> = select(UserState.isAdmin);
    protected readonly delegatesEnabled = !!environment.featureFlags?.delegatesEnabled;

    protected readonly visibleTiles = computed(() =>
        this.allTiles.filter(
            tile => (!tile.adminOnly || this.isAdmin()) && (!tile.requiresDelegatesFeature || this.delegatesEnabled)
        )
    );

    private readonly allTiles: (DashboardItem & { adminOnly?: boolean; requiresDelegatesFeature?: boolean })[] = [
        {
            link: '/seasons',
            label: 'home-dashboard.tiles.season-overview',
            icon: 'observations',
            ariaLabel: 'home-dashboard.tiles.season-overview'
        },
        {
            link: '/season/create',
            label: 'home-dashboard.tiles.create-season',
            icon: 'plus',
            ariaLabel: 'home-dashboard.tiles.create-season',
            adminOnly: true
        },
        {
            link: '/translations',
            label: 'home-dashboard.tiles.translations',
            icon: 'text',
            ariaLabel: 'home-dashboard.tiles.translations',
            adminOnly: true
        },
        {
            link: '/user-management',
            label: 'home-dashboard.tiles.user-management',
            icon: 'user-settings',
            ariaLabel: 'home-dashboard.tiles.user-management',
            adminOnly: true
        },
        {
            link: '/workers-council-groups',
            label: 'home-dashboard.tiles.workers-council-groups',
            icon: 'user-group',
            ariaLabel: 'home-dashboard.tiles.workers-council-groups',
            adminOnly: true,
            requiresDelegatesFeature: true
        }
    ];
}
